import { combineReducers } from 'redux';

import plansFilter from './plansFilterReducer';

import plans from './plansReducer';
import plansPagination from './plansPaginationReducer';
import plansTotalCount from './plansTotalCountReducer';
import planDetails from './planDetailsReducer';
import planCarsList from './planCarsListReducer';
import planDealer from './planDealerReducer';
import planCustomer from './planCustomerReducer';
import activePlansTab from './activePlansTabReducer';
import planCancellationDetails from './planCancellationDetailsReducer';

export default combineReducers({
  plans,
  plansFilter,
  plansPagination,
  plansTotalCount,
  planDetails,
  planCarsList,
  planDealer,
  planCustomer,
  activePlansTab,
  planCancellationDetails,
});
